"use client";

import React, { useEffect } from "react";
import { Modal, Button } from "antd";
import Image from "next/image";
import styles from "./styles.module.scss";
import GIFICON from "@/Assets/teapot.gif";

interface Props {
  open: boolean;
  onClose: () => void;
}

const ClosedBetaModal: React.FC<Props> = ({ open, onClose }) => {

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <Modal
      open={open}
      footer={null}
      centered
      closable={false}
      maskClosable={false}
      keyboard={false}
      width={460}
      className={styles.closedBetaModal}
    >
      {/* GIF HEADER */}
      <div className={styles.gifHeader}>
        <Image
          src={GIFICON}
          alt="Teapot steeping animation"
          fill
          unoptimized
          className={styles.gifImage}
          priority
        />
      </div>

      {/* CONTENT */}
      <div className={styles.content}>
        <h2 className={styles.title}>
          We’re still steeping something special.
        </h2>

        <p className={styles.desc}>
          This app is currently in closed testing.
        </p>

        <Button
          type="primary"
          block
          className={styles.okBtn}
          onClick={onClose}
        >
          OK
        </Button>
      </div>
    </Modal>
  );
};

export default ClosedBetaModal;